// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let JsxRuntime = require("react/jsx-runtime");

function SearchFilterFieldGroup(props) {
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: "flex flex-col md:flex-row gap-4 md:[&>*]:flex-grow"
  });
}

let make = SearchFilterFieldGroup;

exports.make = make;
/* react/jsx-runtime Not a pure module */
